module.exports = __webpack_public_path__ + "img/7-2.b1a2e905.png";